<script>
  import { tick } from "svelte";
  import toast from "svelte-french-toast";
  import Header from "../Component/Header.svelte";
  import { Button, Link, Badge, Textfield, Textarea, RadioGroup, SelectCountry, Select } from "../../Components";
  import { Loading } from "../../Components/Icons";
  import RequiredText from "./MyCongressData/RequiredText.svelte";
  import OverviewButton from "./MyCongressData/OverviewButton.svelte";
  import MyEventsButton from "./MyCongressData/MyEventsButton.svelte";
  import { Teilnehmerkongressanmeldung, Teilnehmerkongressfeedback } from "../Api/congress";
  import { operationStore, query } from "@urql/svelte";
  import { getLinks } from "../Api/congress_stores.js";
  import KongressEventWindow from "./MyCongressData/KongressEventWindow.svelte";
  import KongressEventTimetableOverview from "./MyCongressData/KongressEventTimetableOverview.svelte";
  import KongressEventDetailview from "./MyCongressData/KongressEventDetailview.svelte";
  import KongressEventSmsServiceView from "./MyCongressData/KongressEventSmsServiceView.svelte";

  // TODO add date objects to congress data startdate, enddate, gettoghterdate, feedbackCloseDate
  export let congressId;

  // TODO Fill this with data
  let tninfodata = [];

  const congressLocation = "Congress Center Messe Frankfurt, Ludwig-Erhard-Anlage 1, 60327 Frankfurt am Main";

  const registerLink = getLinks("register");
  const requestPolicy = "network-only";
  const missingDataText = "Daten müssen vervollständigt werden";
  const location = window.location;
  const pathname = location.pathname;

  let showSubpage = location.hash.substring(1) || false;
  let showSubpageEvents = "overview";
  if (showSubpage && showSubpage.indexOf("|") > -1) {
    showSubpageEvents = showSubpage.substring(showSubpage.indexOf("|") + 1);
    showSubpage = showSubpage.substring(0, showSubpage.indexOf("|"));
  }

  let possiblePages = {
    myAccount: true,
    myCongress: true,
    myLectures: false,
    hotelTaxi: false,
    myEvents: true,
    services: false,
  };

  let hasData = {};
  for (const type in possiblePages) {
    if (possiblePages[type]) {
      hasData[type] = false;
    }
  }

  let registration = {
    isGratis: false,
    ansprechperson: "",
    firma: "",
    adresse: "",
    plz: "",
    ort: "",
    land: "",
    email: "",
    telefon: "",
    anmeldeanmerkung: "",
    teilnehmer_anrede: null,
    teilnehmer_titel: "",
    teilnehmer_vorname: "",
    teilnehmer_nachname: "",
    teilnehmer_firma: "",
    teilnehmer_adresse: "",
    teilnehmer_plz: "",
    teilnehmer_ort: "",
    teilnehmer_land: "",
    teilnehmer_email: "",
    teilnehmer_telefon: "",
    teilnehmer_mobilnummer: "",
    teilnehmer_fax: "",
    teilnehmer_branche: "0",
    teilnehmer_taetigkeit: "-1",
    teilnehmer_position: "",
    teilnehmer_taetigkeit_sonstiges: "",
  };

  let congressData = {};

  let feedback = {
    feedbackAnwesenheit: null,
    feedbackLunch: null,
    feedbackLunchType: null,
    feedbackLunchTypeOthers: null,
    feedbackAnwesenheitGala: null,
    feedbackAnwesenheitGettogether: null,
  };

  let inProgress = true;

  const registrationStore = operationStore(Teilnehmerkongressanmeldung, { congressId, action: "" }, { requestPolicy });
  const feedbackStore = operationStore(Teilnehmerkongressfeedback, { congressId, action: "" }, { requestPolicy });
  query(registrationStore);
  query(feedbackStore);

  registrationStore.subscribe((storeObj) => {
    inProgress = storeObj.fetching;

    if (!inProgress && storeObj.data) {
      congressData = storeObj.data.Teilnehmerkongressanmeldung;
      registration = {
        ...registration,
        ...congressData,
        isGratis: !!(congressData.isGratis == 1),
      };

      registration.teilnehmer_branche += "";
      if (
        congressData.teilnehmer_vorname != "" &&
        congressData.teilnehmer_nachname != "" &&
        congressData.teilnehmer_firma != "" &&
        congressData.teilnehmer_adresse != "" &&
        congressData.teilnehmer_plz != "" &&
        congressData.teilnehmer_ort != "" &&
        congressData.teilnehmer_land != "" &&
        congressData.teilnehmer_email != "" &&
        congressData.teilnehmer_mobilnummer != "" &&
        congressData.teilnehmer_telefon != "" &&
        congressData.teilnehmer_branche > 0
      ) {
        hasData["myAccount"] = 1;
      }
    }
  });

  feedbackStore.subscribe((storeObj) => {
    inProgress = storeObj.fetching;

    if (!inProgress && storeObj.data) {
      const data = storeObj.data.Teilnehmerkongressfeedback;
      hasData = {
        ...hasData,
        myCongress: data.feedback_hasdata == 1,
        gettogether: data.feedback_hasGettogether === 1,
        entry_locked: data.feedback_entry_locked === 1,
        presence: data.feedback_anwesenheit.toString(),
        lunch: data.feedback_mittagessen.toString(),
        lunchType: data.feedback_essenswunsch.toString(),
        lunchTypeOther: data.feedback_essenswunsch_sonstiges.toString(),
        presenceGala: data.feedback_anwesenheit_galaabend.toString(),
        presenceGettogether: data.feedback_anwesenheit_gettogether.toString(),
        myEvents: 1,
      };
    }
  });

  async function showPage(target) {
    if (congressData.userIsLoggedIn != 1) {
      window.dispatchEvent(new Event("openLogin"));
      return;
    }
    target = typeof target === "string" && target ? target : false;
    await tick();
    history.pushState(null, null, target ? `#${target}` : pathname);
    showSubpage = target;
    if (target == "myEvents") {
      showSubpageEvents = "overview";
    }
  }

  async function jumptoEventsPageTermin(targetId) {
    if (congressData.userIsLoggedIn != 1) {
      window.dispatchEvent(new Event("openLogin"));
      return;
    }
    await tick();
    history.pushState(null, null, `#myEvents`);
    showSubpage = "myEvents";
    showSubpageEvents = "details";

    window.setTimeout(function () {
      const el = document.querySelector("#" + targetId);
      if (!el) return;
      el.scrollIntoView({
        behavior: "smooth",
      });
    }, 1000);
  }

  async function showEventsSubPage(target) {
    if (congressData.userIsLoggedIn != 1) {
      window.dispatchEvent(new Event("openLogin"));
      return;
    }
    target = typeof target === "string" && target ? target : false;
    await tick();
    history.pushState(null, null, target ? `#${showSubpage}|${target}` : pathname);
    showSubpageEvents = target;
  }

  function handleSaveRegistration() {
    registrationStore.variables = {
      ...registrationStore.variables,
      action: "saveAnmeldung",
      ...registration,
    };
    registrationStore.variables.teilnehmer_land = registration.teilnehmer_land.value;

    registrationStore.reexecute();
    toast.success("Datenänderung wurde übermittelt", { duration: 5000 });
  }

  function handleSaveFeedback() {
    feedback.feedbackAnwesenheit = parseInt(hasData["presence"]);
    feedback.feedbackAnwesenheitGala = parseInt(hasData["presenceGala"]);
    feedback.feedbackAnwesenheitGettogether = parseInt(hasData["presenceGettogether"]);
    feedback.feedbackLunch = parseInt(hasData["lunch"]);
    feedback.feedbackLunchType = parseInt(hasData["lunchType"]);
    feedback.feedbackLunchTypeOthers = hasData["lunchTypeOther"];

    feedbackStore.variables = {
      ...feedbackStore.variables,
      action: "saveFeedback",
      ...feedback,
    };

    feedbackStore.reexecute();
    toast.success("Datenänderung wurde übermittelt", { duration: 5000 });
  }
</script>

<svelte:window
  on:popstate={() => {
    showSubpage = location.hash.substring(1) || false;
    showSubpageEvents = false;
    if (showSubpage.indexOf("|") > -1) {
      showSubpageEvents = showSubpage(showSubpage.indexOf("|") + 1);
      showSubpage = showSubpage.substr(0, showSubpage.indexOf("|"));
    }
  }}
  on:loginSuccessfull={() => {
    registrationStore.reexecute();
    feedbackStore.reexecute();
  }}
/>

<Header {congressId} {...congressData} />

<div class="prose my-8 max-w-none">
  {#if inProgress}
    <Loading class="mx-auto" display="block" />
  {:else if congressData.userIsLoggedIn == 1 && congressData.userHasKongressAnmeldung != 1}
    <p>
      Sie sind noch nicht zum Institutional Money Kongress {congressData?.congressYear || ""} angemeldet. <br />
      <Link href={registerLink} main class="mt-4">Zum Kongress anmelden</Link>
    </p>
  {:else if congressData.userIsLoggedIn != 1}
    <p>
      Klicken Sie <Link link href={registerLink}>hier, um sich zum Kongress anzumelden.</Link><br />
      Falls Sie schon angemeldet sind, <Button link eventOnClick="openLoginModal">klicken Sie bitte hier.</Button>
    </p>
  {:else if !showSubpage}
    <h2 class="text-center text-2xl uppercase text-theme-minor-600">Mein Kongress</h2>
    {#if Object.values(possiblePages).some((entry) => entry)}
      <div class="my-data not-prose mt-8 grid gap-4 sm:grid-cols-2">
        {#if possiblePages.myAccount}
          <OverviewButton pageName="myAccount" headline="Meine Kongressanmeldung" description="Name, Firma und Adressdaten" viewBox="0 0 384 512" {hasData} {showPage}>
            <path
              d="M256 0v128h128L256 0zM192 320c35.35 0 64-28.66 64-64s-28.65-64-64-64C156.7 192 128 220.7 128 256S156.7 320 192 320zM224 352H160c-44.18 0-80 35.81-80 80C80 440.8 87.16 448 96 448h192c8.836 0 16-7.164 16-16C304 387.8 268.2 352 224 352z"
            />
            <path
              class="opacity-40"
              d="M256 128V0H48C21.49 0 0 21.49 0 48v416C0 490.5 21.49 512 48 512h288c26.51 0 48-21.49 48-48V128H256zM192 192c35.35 0 64 28.66 64 64s-28.65 64-64 64c-35.34 0-64-28.66-64-64S156.7 192 192 192zM288 448H96c-8.836 0-16-7.164-16-16C80 387.8 115.8 352 160 352h64c44.18 0 80 35.81 80 80C304 440.8 296.8 448 288 448z"
            />
          </OverviewButton>
        {/if}
        {#if possiblePages.myCongress}
          <OverviewButton pageName="myCongress" headline="Kongresstage, Essen und Gala-Abend" viewBox="0 0 640 512" {hasData} {showPage}>
            <path
              d="M130.3 233.8H120V472C120 478.4 117.5 484.5 112.1 488.1C108.5 493.5 102.4 496 96 496C89.63 496 83.53 493.5 79.03 488.1C74.53 484.5 72 478.4 72 472V233.8H61.86C43.86 230.3 27.64 220.7 15.1 206.6C9.007 197.8 4.107 187.6 1.678 176.7C-.7521 165.8-.6475 154.5 1.984 143.6L27.87 26.75C28.63 23.48 30.56 20.59 33.3 18.64C36.04 16.7 39.4 15.83 42.75 16.19C46.09 16.56 49.18 18.14 51.43 20.64C53.69 23.13 54.95 26.37 54.98 29.73V153.2H69.89L84.54 26.21C84.88 23.4 86.23 20.81 88.34 18.93C90.46 17.05 93.19 16.01 96.02 16.01C98.84 16.01 101.6 17.05 103.7 18.93C105.8 20.81 107.2 23.4 107.5 26.21L122.1 153.2H137V29.73C137.1 26.37 138.3 23.13 140.6 20.64C142.8 18.14 145.9 16.56 149.3 16.19C152.6 15.83 155.1 16.7 158.7 18.64C161.4 20.59 163.4 23.48 164.1 26.75L190 143.6C192.7 154.4 192.8 165.7 190.4 176.6C188 187.5 183.1 197.7 176.2 206.5C164.5 220.6 148.3 230.3 130.3 233.8zM624.3 18.08C627.4 19.41 630.3 21.35 632.6 23.79C635 26.22 636.9 29.1 638.2 32.26C639.4 35.43 640 38.8 640 42.21V472C640 478.4 637.5 484.5 632.1 488.1C628.5 493.5 622.4 496 616 496C609.6 496 603.5 493.5 599 488.1C594.5 484.5 592 478.4 592 472V320H544C535.5 320 527.4 316.6 521.4 310.6C515.4 304.6 512 296.5 512 288L512.4 158.2C512.2 128.3 520.8 99 537.3 74.02C553.7 49.05 577.2 29.51 604.8 17.89C607.8 16.64 611.1 15.1 614.4 16C617.8 16.03 621.2 16.74 624.3 18.07V18.08z"
            />
            <path
              class="opacity-40"
              d="M221 136.5L206.9 72.86C249.5 42.74 301.3 28.49 353.4 32.58C405.4 36.67 454.3 58.85 491.7 95.26C484.4 115.4 480.6 136.7 480.5 158.1V188.3C469.6 164.9 453.3 144.5 432.8 128.8C412.3 113.2 388.3 102.7 362.9 98.31C337.5 93.93 311.4 95.79 286.9 103.7C262.4 111.6 240.1 125.4 222.1 143.8C221.7 141.4 221.8 139 221 136.5zM426.5 165.5C450.5 189.5 464 222.1 464 255.1C464 281.3 456.5 306.1 442.4 327.1C428.4 348.2 408.4 364.6 384.1 374.3C361.6 383.9 335.9 386.5 311 381.5C286.2 376.6 263.4 364.4 245.5 346.5C227.6 328.6 215.4 305.8 210.5 280.1C205.5 256.1 208.1 230.4 217.7 207C227.4 183.6 243.8 163.6 264.9 149.6C285.9 135.5 310.7 127.1 336 127.1C369.9 127.1 402.5 141.5 426.5 165.5zM538.4 351.6C521.7 387.2 495.9 417.7 463.6 440.1C431.3 462.5 393.6 476.1 354.5 479.3C315.3 482.5 275.9 475.4 240.4 458.6C204.9 441.8 174.4 415.9 152 383.6V260.9C160.7 257.8 169 253.6 176.8 248.4C176.6 250.1 176 253.4 176 255.1C175.1 293.4 189 329.6 212.9 358.4C236.9 387.1 270.1 406.5 306.9 413.3C343.7 420.1 381.6 413.7 414.2 395.3C446.8 376.1 471.9 347.8 485.1 312.8C488.3 320.4 492.1 327.3 498.8 333.2C509.4 343.8 523.5 350.3 538.4 351.6H538.4z"
            />
          </OverviewButton>
        {/if}
        {#if possiblePages.myLectures}
          <OverviewButton pageName="myLectures" headline="Meine Kongress-Terminübersicht" description="Vorträge & Termine" viewBox="0 0 576 512" {hasData} {showPage}>
            <path
              d="M288 368C288 288.5 352.5 224 432 224C511.5 224 576 288.5 576 368C576 447.5 511.5 512 432 512C352.5 512 288 447.5 288 368zM432 480C462.2 480 489.5 468.1 509.7 448.7C503.5 429.7 485.6 416 464.6 416H399.4C378.4 416 360.5 429.7 354.3 448.7C374.5 468.1 401.8 480 432 480V480zM432 384C458.5 384 480 362.5 480 336C480 309.5 458.5 288 432 288C405.5 288 384 309.5 384 336C384 362.5 405.5 384 432 384z"
            />
            <path
              class="opacity-40"
              d="M96 32C96 14.33 110.3 0 128 0C145.7 0 160 14.33 160 32V64H288V32C288 14.33 302.3 0 320 0C337.7 0 352 14.33 352 32V64H400C426.5 64 448 85.49 448 112V160H0V112C0 85.49 21.49 64 48 64H96V32zM416 192.7C326.3 200.8 256 276.2 256 368C256 427.5 285.6 480.1 330.8 512H48C21.49 512 0 490.5 0 464V192H416V192.7z"
            />
          </OverviewButton>
        {/if}
        {#if possiblePages.hotelTaxi}
          <OverviewButton pageName="hotelTaxi" headline="Hotel & Taxi Specials" description="Günstige Hotelkontingente & Taxigutschein" viewBox="0 0 512 512" {hasData} {showPage}>
            <path d="M480 368H32c0-123.7 100.3-224 224-224S480 244.3 480 368z" />
            <path
              class="opacity-40"
              d="M215.1 112H232v33.32C239.9 144.5 247.9 144 256 144s16.11 .4844 24 1.324V112h16C309.3 112 320 101.3 320 88S309.3 64 296 64H215.1C202.7 64 192 74.75 192 87.1S202.7 112 215.1 112zM488 400h-464C10.75 400 0 410.7 0 423.1C0 437.3 10.75 448 23.1 448h464c13.25 0 24-10.75 24-23.1C512 410.7 501.3 400 488 400z"
            />
          </OverviewButton>
        {/if}

        {#if possiblePages.myEvents}
          <OverviewButton pageName="myEvents" headline="Mein Kongressprogramm" description="Kongress-Termine" viewBox="0 0 448 512" {hasData} {showPage}>
            <path
              d="M160 32V64H288V32C288 14.33 302.3 0 320 0C337.7 0 352 14.33 352 32V64H400C426.5 64 448 85.49 448 112V192H0V112C0 85.49 21.49 64 48 64H96V32C96 14.33 110.3 0 128 0C145.7 0 160 14.33 160 32zM256.9 298.7L309.7 306.4C318.2 307.6 321.6 318.1 315.4 324.1L277.3 361.3L286.3 413.8C287.7 422.3 278.8 428.8 271.2 424.8L224 400L176.8 424.8C169.2 428.8 160.3 422.3 161.7 413.8L170.7 361.3L132.6 324.1C126.4 318.1 129.8 307.6 138.3 306.4L191.1 298.7L214.7 250.9C218.5 243.2 229.5 243.2 233.3 250.9L256.9 298.7z"
            />
            <path
              class="opacity-40"
              d="M448 464C448 490.5 426.5 512 400 512H48C21.49 512 0 490.5 0 464V192H448V464zM233.3 250.9C229.5 243.2 218.5 243.2 214.7 250.9L191.1 298.7L138.3 306.4C129.8 307.6 126.4 318.1 132.6 324.1L170.7 361.3L161.7 413.8C160.3 422.3 169.2 428.8 176.8 424.8L223.1 400L271.2 424.8C278.8 428.8 287.7 422.3 286.3 413.8L277.3 361.3L315.4 324.1C321.6 318.1 318.2 307.6 309.7 306.4L256.9 298.7L233.3 250.9z"
            />
          </OverviewButton>
        {/if}
        {#if possiblePages.services}
          <OverviewButton pageName="services" headline="Kostenfreie Serviceleistungen" description="Newsletter & Mandate-Tool" viewBox="0 0 512 512" {hasData} {showPage}>
            <path
              d="M384 318.7c-18.1-3.825-32.01-19.18-32.01-38.43v-120.1c0-8.846-7.171-16.02-16.01-16.02l-31.98 .0036c-7.299 0-13.2 4.992-15.12 11.68C274.1 148.6 257.6 144.1 240 144.1c-61.86 0-112 50.2-112 112.1s50.13 112.1 111.1 112.1c26.44 0 50.43-9.544 69.59-24.88C327.1 366.3 353.7 381.7 384 384V318.7zM239.1 304.3c-26.47 0-48-21.56-48-48.05s21.53-48.05 48-48.05s48 21.56 48 48.05S266.5 304.3 239.1 304.3z"
            />
            <path
              class="opacity-40"
              d="M495.1 256.3v20.96c.0001 46.74-29.27 90.22-74.22 103C408.8 383.9 396.1 384.1 384 384v-65.31c2.672 .5651 5.164 1.621 7.1 1.621c22.06 0 40-17.96 40-40.05l0-16.16c.0001-91.97-67.02-174.3-158.6-183.2C168.6 70.76 79.1 153.4 79.1 256.3c0 87.88 64.61 160.9 148.8 174.1c15.62 2.441 27.24 15.5 27.24 31.31c-.0001 19.52-17.42 35.04-36.71 32.07c-130.2-20.08-226.1-145.2-198.5-285.9c18.34-93.45 93.57-168.8 187-187.1C361.2-9.332 495.1 107.1 495.1 256.3z"
            />
          </OverviewButton>
        {/if}
      </div>
    {/if}

    {#if Object.values(hasData).some((entry) => !entry)}
      <p class="flex items-center gap-2"><Badge badge="warning" class="relative" />{missingDataText}</p>
    {/if}
  {:else if showSubpage == "myAccount"}
    <h2>Meine Kongressanmeldung</h2>
    <Button on:click={showPage}>Zurück zur Übersicht</Button>
    <form class="not-prose" on:submit|preventDefault={handleSaveRegistration}>
      <RequiredText />
      {#if !registration.isGratis}
        <fieldset class="my-4">
          <legend class="text-lg font-bold opacity-70">Rechnungsempfänger</legend>
          <Textfield label="Rechnungsempfänger" required bind:value={registration.ansprechperson} />
          <Textfield label="Firma" required bind:value={registration.firma} />
          <Textfield label="Strasse/Hausnummer/Türnummer" required bind:value={registration.adresse} />
          <div class="my-4 flex flex-col gap-4 sm:flex-row">
            <Textfield label="PLZ" required bind:value={registration.plz} />
            <Textfield label="Ort" class="sm:flex-1" required bind:value={registration.ort} />
          </div>
          <SelectCountry required bind:value={registration.land} />
          <Textfield label="E-Mail" required type="email" bind:value={registration.email} />
          <Textfield label="Telefon" required type="tel" bind:value={registration.telefon} />
        </fieldset>
      {/if}
      <fieldset class="my-4">
        <legend class="text-lg font-bold opacity-70">Anmeldung</legend>
        <Textarea label="Anmerkung" bind:value={registration.anmeldeanmerkung} />
      </fieldset>
      <fieldset class="my-4">
        <legend class="text-lg font-bold opacity-70">Teilnehmende Person</legend>
        <RadioGroup
          bind:group={registration.teilnehmer_anrede}
          required
          options={[
            { value: 1, label: "Frau" },
            { value: 0, label: "Herr" },
          ]}
        />
        <Textfield label="Titel" bind:value={registration.teilnehmer_titel} />
        <div class="my-4 flex flex-col gap-4 sm:flex-row">
          <Textfield label="Vorname" class="sm:flex-1" required bind:value={registration.teilnehmer_vorname} />
          <Textfield label="Nachname" class="sm:flex-1" required bind:value={registration.teilnehmer_nachname} />
        </div>
        <Textfield label="Firma" required bind:value={registration.teilnehmer_firma} />
        <Textfield label="Strasse/Hausnummer/Türnummer" required bind:value={registration.teilnehmer_adresse} />
        <div class="my-4 flex flex-col gap-4 sm:flex-row">
          <Textfield label="PLZ" required bind:value={registration.teilnehmer_plz} />
          <Textfield label="Ort" class="sm:flex-1" required bind:value={registration.teilnehmer_ort} />
        </div>
        <SelectCountry required bind:value={registration.teilnehmer_land} />
        <Textfield label="E-Mail (ist auch Username)" required type="email" bind:value={registration.teilnehmer_email} />
        <Textfield label="Mobil" required type="tel" bind:value={registration.teilnehmer_mobilnummer} />
        <Textfield label="Telefon" required type="tel" bind:value={registration.teilnehmer_telefon} />
        <Textfield label="Fax" type="tel" bind:value={registration.teilnehmer_fax} />
        <Select
          label="Branche"
          placeholder="Bitte wählen Sie…"
          placeholderValue={0}
          required
          valueKey="branchen_id"
          labelKey="branchenname"
          bind:value={registration.teilnehmer_branche}
          options={congressData.branchenlist || []}
        />
        <!-- TODO replace this data with dynamic data
        <Select
          label="Tätigkeitsbereich"
          placeholder={registration.teilnehmer_branche ? "Bitte wählen Sie…" : "Bitte zuerst Branche angeben"}
          placeholderValue={0}
          required
          bind:value={registration.teilnehmer_taetigkeit}
          options={[]}
        />
         -->
      </fieldset>
      <Button type="submit" main>Datenänderung übermitteln</Button>
    </form>
  {:else if showSubpage == "myCongress"}
    <h2>Mein Kongress</h2>
    <Button on:click={showPage}>Zurück zur Übersicht</Button>
    <table class="text-lg">
      <tbody>
        {#if congressData?.congressDay1}
          <tr>
            <th>Termin</th>
            <td>{congressData.congressDay1}. {congressData.congressMonth1} bis {congressData.congressDay2}. {congressData.congressMonth2} {congressData.congressYear}</td>
          </tr>
        {/if}
        {#if congressLocation}
          <tr>
            <th>Ort</th>
            <td>{congressLocation}</td>
          </tr>
        {/if}
      </tbody>
    </table>
    {#if hasData["entry_locked"]}
      <p>Ihre Auswahl für die Teilnahme am Kongress sowie am Galaabend wurden bereits erfasst. Nachfolgend finden Sie eine Übersicht der von Ihnen gewählten Optionen.</p>
      <p>
        <strong>Beachten Sie:</strong> Änderungen können ab sofort ausschließlich via E-Mail an <a href="mailto:kongress@institutional-money.com">kongress@institutional-money.com</a> vorgenommen werden.
      </p>
    {/if}
    <form class="not-prose" on:submit|preventDefault={handleSaveFeedback}>
      <fieldset class="my-4">
        <legend class="text-lg font-bold opacity-70">Anwesenheit - ich beabsichtige eine Teilnahme</legend>
        {#if hasData["entry_locked"]}
          {#if hasData["presence"] == 1}
            <RadioGroup bind:group={hasData["presence"]} required row options={[{ value: "1", label: "An beiden Tagen" }]} />
          {:else if hasData["presence"] == 2}
            <RadioGroup bind:group={hasData["presence"]} required row options={[{ value: "2", label: `Nur am ${congressData.congressDay1}. ${congressData.congressMonth1}` }]} />
          {:else if hasData["presence"] == 3}
            <RadioGroup bind:group={hasData["presence"]} required row options={[{ value: "3", label: `Nur am ${congressData.congressDay2}. ${congressData.congressMonth2}` }]} />
          {/if}
        {:else}
          <RadioGroup
            bind:group={hasData["presence"]}
            required
            row
            options={[
              { value: "1", label: "An beiden Tagen" },
              { value: "2", label: `Nur am ${congressData.congressDay1}. ${congressData.congressMonth1}` },
              { value: "3", label: `Nur am ${congressData.congressDay2}. ${congressData.congressMonth2}` },
            ]}
          />
        {/if}
      </fieldset>
      <fieldset class="my-4">
        <legend class="text-lg font-bold opacity-70">Gesetztes Mittagessen im Rahmen des Kongresses</legend>
        {#if hasData["entry_locked"]}
          {#if hasData["lunch"] == 1}
            <RadioGroup bind:group={hasData["lunch"]} required row options={[{ value: "1", label: "An beiden Tagen" }]} />
          {:else if hasData["lunch"] == 2}
            <RadioGroup bind:group={hasData["lunch"]} required row options={[{ value: "2", label: `Nur am ${congressData.congressDay1}. ${congressData.congressMonth1}` }]} />
          {:else if hasData["lunch"] == 3}
            <RadioGroup bind:group={hasData["lunch"]} required row options={[{ value: "3", label: `Nur am ${congressData.congressDay2}. ${congressData.congressMonth2}` }]} />
          {/if}
        {:else}
          <RadioGroup
            bind:group={hasData["lunch"]}
            required
            row
            options={[
              { value: "1", label: "An beiden Tagen" },
              { value: "2", label: `Nur am ${congressData.congressDay1}. ${congressData.congressMonth1}` },
              { value: "3", label: `Nur am ${congressData.congressDay2}. ${congressData.congressMonth2}` },
            ]}
          />
        {/if}
      </fieldset>
      <fieldset class="my-4">
        {#if hasData["entry_locked"]}
          <legend class="text-lg font-bold opacity-70">Verpflegung</legend>
          {#if hasData["lunchType"] == 1}
            <RadioGroup bind:group={hasData["lunchType"]} required row options={[{ value: "1", label: "Keine speziellen Wünsche" }]} />
          {:else if hasData["lunchType"] == 2}
            <RadioGroup bind:group={hasData["lunchType"]} required row options={[{ value: "2", label: "Vegetarisch" }]} />
          {:else if hasData["lunchType"] == 3}
            <RadioGroup bind:group={hasData["lunchType"]} required row options={[{ value: "3", label: "Vegan" }]} />
          {:else if hasData["lunchType"] == 4}
            <RadioGroup bind:group={hasData["lunchType"]} required row options={[{ value: "4", label: "Sonstiges" }]} />
            <p>
              {hasData["lunchTypeOther"]}
            </p>
          {/if}
        {:else}
          <legend class="text-lg font-bold opacity-70">Bitte vermerken Sie Ihre Wünsche hinsichlich der Verpflegung</legend>
          <RadioGroup
            bind:group={hasData["lunchType"]}
            required
            row
            options={[
              { value: "1", label: "Keine speziellen Wünsche" },
              { value: "2", label: "Vegetarisch" },
              { value: "3", label: "Vegan" },
              { value: "4", label: "Sonstiges" },
            ]}
          />
          {#if hasData["lunchType"] == "4"}
            <Textfield label="Sonstiges" required bind:value={hasData["lunchTypeOther"]} />
          {/if}
        {/if}
      </fieldset>
      <fieldset class="my-4">
        <legend class="text-lg font-bold opacity-70">Galaabend am {congressData.congressDay1}. {congressData.congressMonth1} {congressData.congressYear} in der Alten Oper Frankfurt</legend>
        {#if hasData["entry_locked"]}
          {#if hasData["presenceGala"] == 1}
            <RadioGroup bind:group={hasData["presenceGala"]} required row options={[{ value: "1", label: "Gerne nehme ich am Galaabend teil" }]} />
          {:else if hasData["presenceGala"] == 2}
            <RadioGroup
              bind:group={hasData["presenceGala"]}
              required
              row
              options={[
                { value: "1", label: "Gerne nehme ich am Galaabend teil" },
                { value: "2", label: "Leider kann ich am Galaabend nicht teilnehmen" },
              ]}
            />
          {/if}
        {:else}
          <RadioGroup
            bind:group={hasData["presenceGala"]}
            required
            row
            options={[
              { value: "1", label: "Gerne nehme ich am Galaabend teil" },
              { value: "2", label: "Leider kann ich am Galaabend nicht teilnehmen" },
            ]}
          />
        {/if}
        {#if hasData["presenceGala"] != 2}
          <p class="text-sm">Ein Shuttle-Bus wird Sie bequem vom CongressCenter direkt zur Alten Oper Frankfurt bringen. Einlass ist ab 19:00 Uhr. Beginn 19:45 Uhr.</p>
        {/if}
      </fieldset>
      {#if hasData.gettogether}
        <fieldset class="my-4">
          <!-- TODO replace this date with dynamic date-->
          <legend class="text-lg font-bold opacity-70"
            >Get-Together am 23. März 2026, ab 19:30 Uhr in der Skybar OBEN<br />(<a
              target="_blank"
              href="https://www.bing.com/maps?mepi=101%7E%7EUnknown%7EAddress_Link&ty=18&q=Oben+Restaurant+%26+Skybar&ss=ypid.YN6740x8793168751216933574&ppois=50.116172790527344_8.651572227478027_Oben+Restaurant+%26+Skybar_YN6740x8793168751216933574%7E&cp=50.116175%7E8.651562&v=2&sV=1&FORM=MPSRPL&lvl=16.0"
              >Hotel Meliá, Senckenberganlage 13, 60325 Frankfurt</a
            >)</legend
          >
          {#if hasData["entry_locked"]}
            {#if hasData["presenceGettogether"] == 1}
              <RadioGroup bind:group={hasData["presenceGettogether"]} required row options={[{ value: "1", label: "Gerne nehme ich am Get-Together teil" }]} />
            {:else if hasData["presenceGettogether"] == 1}
              <RadioGroup bind:group={hasData["presenceGettogether"]} required row options={[{ value: "2", label: "Leider kann ich am vorabendlichen Get-Together nicht teilnehmen" }]} />
            {/if}
          {:else}
            <RadioGroup
              bind:group={hasData["presenceGettogether"]}
              required
              row
              options={[
                { value: "1", label: "Gerne nehme ich am Get-Together teil" },
                { value: "2", label: "Leider kann ich am vorabendlichen Get-Together nicht teilnehmen" },
              ]}
            />
          {/if}
          <p class="text-sm">
            Das vorabendliche Get-Together ist eine hervorragende Gelegenheit, sich unter Branchenkollegen in angenehmer Atmosphäre auszutauschen, andere Investoren kennenzulernen oder bekannte
            Gesichter wieder zu treffen – ein guter Anlass, um sich auf den Kongress einzustimmen. Personen aus dem Sales bzw. aus dem Produktvertrieb sind nicht zugelassen.
          </p>
        </fieldset>
      {/if}

      {#if !hasData.myCongress}
        {#if !hasData["entry_locked"]}
          <!-- TODO replace this date with dynamic date-->
          <p class="my-4 font-bold">Vielen Dank für Ihre Rückmeldung bis 11. März 2026.</p>
        {/if}
      {/if}

      {#if !hasData["entry_locked"]}
        <Button type="submit" main>Abschicken</Button>
      {/if}
    </form>
  {:else if showSubpage == "myLectures"}
    <h2>Meine Kongress-Terminübersicht</h2>
    <Button on:click={showPage}>Zurück zur Übersicht</Button>
    <KongressEventWindow {tninfodata} />
  {:else if showSubpage == "hotelTaxi"}
    <h2>Hotel & Taxi Specials</h2>
    <Button on:click={showPage}>Zurück zur Übersicht</Button>
  {:else if showSubpage == "myEvents"}
    <h2>Mein Kongressprogramm</h2>
    <Button on:click={showPage}>Zurück zur Übersicht</Button>

    <MyEventsButton myeventPageName="overview" viewBox="0 0 512 512" {showEventsSubPage} active={showSubpageEvents == "overview"}>Terminübersicht</MyEventsButton>
    <MyEventsButton myeventPageName="details" viewBox="0 0 512 512" {showEventsSubPage} active={showSubpageEvents == "details"}>Detailansicht</MyEventsButton>
    <MyEventsButton myeventPageName="sms_service" viewBox="0 0 512 512" {showEventsSubPage} active={showSubpageEvents == "sms_service"}>SMS-Service</MyEventsButton>

    <br />
    <a href="/fpiAuth/?eID=teilnehmerterminpdf&tid={congressData.tid}&h={congressData.teilnehmerHash}" target="_blank" class="flex text-theme-signal *:p-1"
      >Termine als PDF <span
        ><svg version="1.1" class="w-6" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 58.5" xml:space="preserve">
          <path d="M10.6 0h38.8C55.2 0 60 4.8 60 10.6v37.2c0 5.9-4.8 10.6-10.6 10.6H10.6C4.8 58.5 0 53.7 0 47.9V10.6C0 4.8 4.8 0 10.6 0z" fill="#b30b00" />
          <path
            d="M48.2 33.9C47 32.6 44.7 32 41.4 32c-1.8 0-3.7.2-5.5.5-1.2-1.1-2.2-2.4-3.2-3.7-.7-1-1.4-2-2-3.1 1-2.8 1.6-5.8 1.8-8.8 0-2.7-1.1-5.6-4.1-5.6-1 0-2 .6-2.5 1.5-1.3 2.2-.8 6.7 1.3 11.4-.7 2.1-1.5 4.2-2.4 6.5-.8 2-1.7 3.9-2.8 5.7-3.1 1.2-9.6 4.2-10.2 7.5-.2 1 .1 2 .9 2.6.7.6 1.7 1 2.7.9 3.9 0 7.8-5.4 10.5-10.1 1.5-.5 3-1 4.6-1.4 1.7-.4 3.3-.8 4.8-1.1 4.2 3.6 7.9 4.2 9.7 4.2 2.5 0 3.5-1.1 3.8-2 .4-1.1.2-2.3-.6-3.1zm-2.7 1.9c-.1.7-.9 1.2-1.9 1.2-.3 0-.6 0-.9-.1-2-.5-3.9-1.5-5.5-2.8 1.3-.2 2.7-.3 4-.3.9 0 1.8.1 2.7.2.9.2 1.9.6 1.6 1.8zM27.6 13.7c.2-.3.5-.5.9-.6 1 0 1.2 1.1 1.2 2.1-.1 2.3-.5 4.5-1.2 6.7-1.7-4.3-1.5-7.2-.9-8.2zm5.6 19.2c-1.1.2-2.2.5-3.3.8-.8.2-1.6.5-2.5.7.4-.9.8-1.8 1.2-2.6.5-1.1.9-2.2 1.3-3.3.4.6.7 1.1 1.1 1.6.7 1 1.5 1.9 2.2 2.8zm-12.1 5.8c-2.5 4-5 6.6-6.4 6.6-.2 0-.5-.1-.6-.2-.3-.2-.4-.6-.3-.9.2-1.5 3.1-3.6 7.3-5.5z"
            fill="#fff"
          />
        </svg></span
      ></a
    >

    {#if showSubpageEvents == "overview"}
      <KongressEventTimetableOverview {congressId} {congressData} {jumptoEventsPageTermin}></KongressEventTimetableOverview>
    {:else if showSubpageEvents == "details"}
      <KongressEventDetailview {congressId}></KongressEventDetailview>
    {:else if showSubpageEvents == "sms_service"}
      <KongressEventSmsServiceView {congressId}></KongressEventSmsServiceView>
    {/if}
  {:else if showSubpage == "services"}
    <h2>Kostenfreie Serviceleistungen</h2>
    <Button on:click={showPage}>Zurück zur Übersicht</Button>
  {/if}
</div>

<style>
  .my-data :global(.btn--ghost__text) {
    width: 100%;
  }
</style>
